import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import PagesPaginatedGql from '@/extensions/eventManager/store/graphql/queries/PagesPaginated.gql';

export default {
    fetchPagesPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: PagesPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 80),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        link: _.get(data, 'variables.link', '/posts/'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.CP_PagesPaginated))
                .catch(err => reject(err));
        })
};
